export enum StorageKeys {
  Token = 'token',
  User = 'user',
  Role = 'role',
  TablesOpenSeatPanels = 'tables-open-seat-panels',
  TablesAreaFilter = 'tables-area-filter',
  TablesLastSelectedClub = 'tables-last-selected-club',

  TrainerSessionStatusFilter = 'trainer-session-status-filter',
}

export const storageService = {
  setItem: (key: StorageKeys, value: string) => {
    localStorage.setItem(key, value);
  },
  getItem: (key: StorageKeys): string | null => {
    return localStorage.getItem(key);
  },
  removeItem: (key: StorageKeys) => {
    localStorage.removeItem(key);
  },
  setAuth: (token: string, user: string, role: string) => {
    localStorage.setItem(StorageKeys.Token, token);
    localStorage.setItem(StorageKeys.User, user);
    localStorage.setItem(StorageKeys.Role, role);
  },
  clearAuth: () => {
    localStorage.removeItem(StorageKeys.Token);
    localStorage.removeItem(StorageKeys.User);
    localStorage.removeItem(StorageKeys.Role);
  },
  clearSessionData: () => {
    localStorage.removeItem(StorageKeys.TablesOpenSeatPanels);
    localStorage.removeItem(StorageKeys.TablesAreaFilter);
    localStorage.removeItem(StorageKeys.TablesLastSelectedClub);

    localStorage.removeItem(StorageKeys.TrainerSessionStatusFilter);
  },
  clearAppData: () => {
    storageService.clearAuth();
    storageService.clearSessionData();
  },
};
